import React from "react";
import { FaSyncAlt, FaRegCheckCircle } from "react-icons/fa";
import useAppUpdateCheck from "../../Hooks/useAppUpdateCheck";
// Dashboard'daki "her şey yolunda" maskotu — panelin görsel dili.
import mascotHappy from "../../Assets/icons/okkali_calculator_mascot_happy.png";

/**
 * Panel güncelleme kapısı — App'in kökünde bir kez render edilir.
 *
 * İki durum:
 *  1) YENİ DAĞITIM (zorunlu): sunucuda yeni bir build var. Modal
 *     KAPATILAMAZ; tek çıkış "Güncelle ve Devam Et" → sayfa yenilenir.
 *     Eski panelle çalışmaya devam etmek, kaldırılmış uçlara istek atmak
 *     demek olduğu için bu bilinçli olarak zorunludur.
 *  2) YENİ SÜRÜM NOTU: kullanıcı güncel build'de ama bu sürümün notlarını
 *     henüz görmemiş. Bilgilendirme modalı, "Tamam" ile kapanır ve bir daha
 *     aynı sürüm için açılmaz.
 */
export default function AppUpdateGate() {
  const { updateAvailable, pendingReleases, currentVersion, acknowledge } =
    useAppUpdateCheck();

  const showForced = updateAvailable;
  const showNotes = !updateAvailable && pendingReleases.length > 0;
  if (!showForced && !showNotes) return null;

  // Zorunlu güncellemede notlar henüz eski dosyadan okunmuş olabilir; o
  // yüzden orada not listesi göstermiyoruz — yenilemeden sonra bu sürümün
  // notları "yeni sürüm notu" modalıyla zaten çıkacak.
  const releases = showNotes ? pendingReleases : [];

  return (
    // KAPANIŞIN TEK YOLU "Tamam"/"Güncelle" butonudur: arka plana tıklama ve
    // ESC bilerek bağlanmadı. "Tamam"a basıldığı an o güne kadarki tüm sürüm
    // notları okunmuş sayılır (en güncel sürüm işaretlenir).
    <div className="fixed inset-0 z-[10200] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-lg max-h-[85vh] flex flex-col bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div
          className={`flex items-center gap-3 px-5 py-4 border-b ${
            showForced
              ? "bg-amber-50 border-amber-100"
              : "bg-emerald-50 border-emerald-100"
          }`}
        >
          <img
            src={mascotHappy}
            alt=""
            aria-hidden="true"
            className="w-16 h-16 sm:w-20 sm:h-20 object-contain shrink-0 drop-shadow"
            draggable={false}
          />
          <div className="min-w-0">
            <h3 className="text-base font-Bold text-gray-800">
              {showForced ? "Yeni sürüm yayınlandı" : "Panelde neler değişti?"}
            </h3>
            <p className="text-xs text-gray-500 mt-0.5">
              {showForced
                ? "Devam etmek için panelin güncellenmesi gerekiyor."
                : `Sürüm ${releases[0]?.version || currentVersion || ""}`}
            </p>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {showForced ? (
            <p className="text-sm text-gray-600 leading-relaxed">
              Panelin yeni sürümü yayına alındı. Açık olan bu sekme eski
              sürümü kullanıyor; bazı ekranlar hatalı çalışabilir. Aşağıdaki
              butona basınca panel yenilenecek ve güncel sürümle devam
              edeceksiniz.
              <span className="block mt-2 text-xs text-gray-400">
                Kaydetmediğiniz bir form varsa önce onu tamamlayın —
                yenileme sırasında kaybolur.
              </span>
            </p>
          ) : (
            <div className="space-y-5">
              {releases.map((release) => (
                <div key={release.version}>
                  <div className="flex items-baseline gap-2 mb-2">
                    <span className="text-sm font-Bold text-gray-800">
                      {release.title || `Sürüm ${release.version}`}
                    </span>
                    <span className="text-[11px] text-gray-400">
                      v{release.version}
                      {release.date ? ` · ${release.date}` : ""}
                    </span>
                  </div>
                  <ul className="space-y-2">
                    {(release.notes || []).map((note, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <FaRegCheckCircle className="w-3.5 h-3.5 mt-0.5 shrink-0 text-emerald-500" />
                        <span className="text-sm text-gray-600 leading-snug">
                          {note}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="px-5 py-4 border-t border-gray-100 bg-gray-50/60">
          <button
            type="button"
            onClick={() => acknowledge({ reload: showForced })}
            className={`w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-SemiBold text-white transition-colors ${
              showForced
                ? "bg-amber-500 hover:bg-amber-600"
                : "bg-emerald-500 hover:bg-emerald-600"
            }`}
          >
            {showForced ? (
              <>
                <FaSyncAlt className="w-4 h-4" /> Güncelle ve Devam Et
              </>
            ) : (
              "Tamam"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
